import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hasActiveGame: false,
  difficultyKey: "medium",
  round: null,
  time: 0,
  gameTrxId: null
};

const zipGameSlice = createSlice({
  name: "zipGameSlice",
  initialState,
  reducers: {
    saveZipGameState: (state, action) => {
      console.log(action.payload.gameTrxId,'gametrxid');
      state.hasActiveGame = true;
      state.gameTrxId = action.payload.gameTrxId ?? state.gameTrxId;
      state.difficultyKey = action.payload.difficultyKey;
      state.round = action.payload.round;
      state.time = action.payload.time ?? state.time;
      return state;
    },
    clearZipGameState: (state) => {
      state.hasActiveGame = false;
      state.difficultyKey = "medium";
      state.gameTrxId = null;
      state.round = null;
      state.time = 0;
      return state;
    },
    updateZipGameTime: (state, action) => {
      state.time = action.payload;
      return state;
    },
  },
});

export const {
  saveZipGameState,
  clearZipGameState,
  updateZipGameTime,
} = zipGameSlice.actions;

export default zipGameSlice;